import UserProfil from '@/generated/controls/user/UserProfil.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: UserProfil
})

